import styled from 'styled-components';

export const Message = styled.div`
  color: rgba(0, 0, 0, 0.87);
  position: relative;
  min-height: 1em;
  margin: 1em 0;
  background: #f8f8f9;
  padding: 1em 1.5em;
  line-height: 1.4285em;
  border: 1px solid #ddd;
`;

export const ErrorMessage = styled.div`
  color: rgba(0, 0, 0, 0.87);
  position: relative;
  min-height: 1em;
  margin: 1em 0;
  padding: 1em 1.5em;
  line-height: 1.4285em;
  background-color: #fff6f6;
  color: #9f3a38;
  border-color: #9f3a38;
`;
